import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { MapPin, ArrowDown } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1581141444721-0e6f8fa8397e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBtb3NxdWUlMjBhcmNoaXRlY3R1cmUlMjBleHRlcmlvcnxlbnwwfHx8fDE3ODA4MTg2Mzd8MA&ixlib=rb-4.1.0&q=85";

export default function Hero({ content }) {
  const { t, lang } = useLang();
  const title = lang === "ta" ? content?.hero_title_ta : content?.hero_title_en;
  const subtitle = lang === "ta" ? content?.hero_subtitle_ta : content?.hero_subtitle_en;
  const fontH = lang === "ta" ? "font-serif-ta" : "font-serif-en";

  return (
    <section id="home" data-testid="hero-section" className="relative h-[88vh] min-h-[560px] w-full overflow-hidden">
      <img src={HERO_IMG} alt="Mosque" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-emerald-950/70" />
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 h-full flex flex-col justify-end pb-16 md:pb-24">
        <div className="fade-up max-w-3xl text-white">
          <div className="inline-flex items-center gap-2 text-amber-300 text-xs uppercase tracking-[0.3em] mb-5">
            <span className="w-8 h-px bg-amber-300" />
            <MapPin className="w-3.5 h-3.5" />
            Kodungaiyur · Chennai
          </div>
          <h1
            data-testid="hero-title"
            className={`${fontH} text-4xl sm:text-5xl lg:text-7xl font-semibold leading-[1.05] tracking-tight`}
          >
            {title}
          </h1>
          <p className={`mt-6 text-base md:text-lg text-stone-100/90 max-w-2xl ${lang === "ta" ? "font-sans-ta" : ""}`}>
            {subtitle}
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <a
              data-testid="hero-cta-prayer"
              href="#prayer"
              className="btn-gold"
            >
              {t("hero_cta")}
            </a>
            <a
              data-testid="hero-cta-visit"
              href="#contact"
              className="px-6 py-3 rounded-full text-white border border-white/40 hover:bg-white/10 transition-all"
            >
              {t("hero_cta2")}
            </a>
          </div>
        </div>
        <a href="#prayer" className="hidden md:flex items-center gap-2 text-white/80 text-xs uppercase tracking-[0.25em] mt-12 hover:text-amber-300 transition-colors">
          <ArrowDown className="w-4 h-4 animate-bounce" />
          Scroll
        </a>
      </div>
    </section>
  );
}
